import {
  Campaign,
  Experiment,
  ExperimentAnalysisConfigView,
  ExperimentAvailability,
  InterferenceView,
  MessageTemplate,
  Rollout,
  RolloutHistory,
  VariableInfo,
  VariableStatsView,
} from '../../lib/PlannerDTOs';

export type Entity =
  | VariableInfo
  | VariableStatsView
  | Experiment
  | Rollout
  | RolloutHistory
  | MessageTemplate
  | Campaign
  | InterferenceView
  | ExperimentAvailability
  | ExperimentAnalysisConfigView;

export enum Service {
  PLANNER = 'PLANNER',
  TRANSMITTER = 'TRANSMITTER',
}
